import { writable } from 'svelte/store';

/**
 * How many portaled floating layers (select menus, calendar popovers) are currently open.
 *
 * Component libraries portal these layers to <body>, i.e. outside any modal, and some of them move
 * focus into the layer when it opens. An active focus trap then pulls focus back into the modal, the
 * library moves it out again, and the two document-level handlers keep re-entering each other until
 * the call stack overflows: an uncaught `RangeError: Maximum call stack size exceeded` that breaks
 * the interaction (reproduced in a real browser in 设置 → 管理员 → 工具 → 千川配置, where opening the
 * manual-sync calendar threw repeatedly).
 *
 * `Modal.svelte` subscribes to this counter and pauses its focus trap while a layer is open, so the
 * two never fight. Layer owners call `trackFloatingLayer()` when they open and the returned
 * function when they close.
 */
export const openFloatingLayers = writable(0);

export function trackFloatingLayer() {
	openFloatingLayers.update((count) => count + 1);
	let tracked = true;
	return () => {
		// Closing twice (or unmounting after a close) must not drive the counter negative.
		if (!tracked) return;
		tracked = false;
		openFloatingLayers.update((count) => Math.max(0, count - 1));
	};
}
